/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const arrowLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M20 11.2H6.8l3.7-3.7-1-1L3.9 12l5.6 5.5 1-1-3.7-3.7H20z" />
	</SVG>
);

export default arrowLeft;
